import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { Observable, Subject, Subscription } from "rxjs";

import { CardType } from "./card-type";
import { DashboardService } from "../dashboard.service";
import { indicate } from "maps-angular-components";

@Component({
  selector: "app-cards",
  templateUrl: "./cards.component.html",
  styleUrls: ["./cards.component.scss"],
})
export class CardsComponent implements OnInit, OnDestroy {

  private subscriptions = new Subscription();

  upCountOptions = { separator: ".", decimal: "" };

  CARD_TYPES = CardType;
  cardSeleted = CardType.NENHUM;
  @Output()
  private onCardSelected: EventEmitter<CardType> = new EventEmitter<CardType>();
  qtdEmAberto = 100;

  qtdCartEnquadrada$: Observable<any>;
  loadingCartEnquadrada$ = new Subject<boolean>();

  qtdCartDesenquadrada$: Observable<any>;
  loadingCartDesenquadrada$ = new Subject<boolean>();

  qtdCartProcessadas$: Observable<any>;
  loadingCartProcessadas$ = new Subject<boolean>();

  qtdCartNaoProcessadas$: Observable<any>;
  loadingCartNaoProcessadas$ = new Subject<boolean>();

  qtdCartAssociadas$: Observable<any>;
  loadingCartAssociadas$ = new Subject<boolean>();

  qtdCartNaoAssociadas$: Observable<any>;
  loadingCartNaoAssociadas$ = new Subject<boolean>();

  qtdRegraEnquadrada$: Observable<any>;
  loadingRegraEnquadrada$ = new Subject<boolean>();

  qtdRegraDesenquadrada$: Observable<any>;
  loadingRegraDesenquadrada$ = new Subject<boolean>();

  qtdCartCanceladas$: Observable<any>;
  loadingCartCanceladas$ = new Subject<boolean>();

  constructor(
    private dashboardService: DashboardService,
    private changeDetectorRef: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.refreshCards();
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  changeCardState(card: CardType) {
    this.cardSeleted = card;
    this.onCardSelected.emit(card);
    this.changeDetectorRef.detectChanges();
  }

  public refreshCards() {

    this.qtdCartEnquadrada$ = this.dashboardService
      .getQuantidadeCarteiraEnquadrada()
      .pipe(indicate(this.loadingCartEnquadrada$));

    this.qtdCartDesenquadrada$ = this.dashboardService
      .getQuantidadeCarteiraDesenquadrada()
      .pipe(indicate(this.loadingCartDesenquadrada$));

    this.qtdCartProcessadas$ = this.dashboardService
      .getQuantidadeCarteiraProcessada()
      .pipe(indicate(this.loadingCartProcessadas$));

    this.qtdCartNaoProcessadas$ = this.dashboardService
      .getQuantidadeCarteiraNaoProcessada()
      .pipe(indicate(this.loadingCartNaoProcessadas$));

    this.qtdCartAssociadas$ = this.dashboardService
      .getQuantidadeCarteiraAssociadas()
      .pipe(indicate(this.loadingCartAssociadas$));

    this.qtdCartNaoAssociadas$ = this.dashboardService
      .getQuantidadeCarteiraNaoAssociadas()
      .pipe(indicate(this.loadingCartNaoAssociadas$));

    this.qtdRegraEnquadrada$ = this.dashboardService
      .getQuantidadeRegraEnquadrada()
      .pipe(indicate(this.loadingRegraEnquadrada$));

    this.qtdRegraDesenquadrada$ = this.dashboardService
      .getQuantidadeRegraDesenquadrada()
      .pipe(indicate(this.loadingRegraDesenquadrada$));

    this.qtdCartCanceladas$ = this.dashboardService
      .getQuantidadeCarteiraCancelada()
      .pipe(indicate(this.loadingCartCanceladas$));
  }
}
